module.exports = __webpack_public_path__ + "static/media/yaju.584ef316.png";